export default __webpack_public_path__ + "static/media/Nwankwo_Uayemen.879f0f46.png";